<template>
	<div class="py-5" id="search" v-if="loading === true">
		<div class="loading">
			<div class="ball bg-indigo-400"></div>
			<div class="ball bg-indigo-400"></div>
			<div class="ball bg-indigo-400"></div>
		</div>
	</div>
	<div class="py-5 px-3" id="search" v-else>
		<div class="flex h-32 md:h-48 container mx-auto bg-gray-800">
			<div class="h-full w-32 md:w-48">
				<img
					:src="res.header_image_url"
					class="h-full w-full object-cover"
					alt=""
				/>
			</div>
			<div class="ml-3 pt-3">
				<h1 class="font-bold text-2xl uppercase text-gray-300">
					{{ res.title }}
				</h1>
				<p class="text-gray-500">
					By:
					<router-link
						class="underline"
						:to="'/artist/' + res.primary_artist.id"
						>{{ res.primary_artist.name }}</router-link
					>
					in
					{{ res.release_date.substring(0, 4) }}
				</p>
			</div>
		</div>
		<div class="container mx-auto mt-4">
			<iframe
				width="100%"
				v-if="youtubeUrl !== ''"
				:src="youtubeUrl"
				frameborder="0"
				allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>
			<a
				class="text-white bg-orange-500 font-bold rounded hover:bg-orange-400 p-2 text-center"
				v-if="youtubeUrl === ''"
				:href="soundCloudUrl"
				>View on SoundCloud</a
			>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'Song',
	data: () => ({
		res: {},
		youtubeUrl: '',
		soundCloudUrl: '',
		loading: true
	}),
	mounted() {
		const that = this;
		axios
			.get(
				`https://api.genius.com/songs/${that.$route.params.id}?access_token=DAwGk4MUWCAT3R5WlGUWVy7TCfyXrHyUNn52O9snc17yhn51c7CcU4GQMfJ5lQcU`
			)
			.then(res => {
				if (
					res.data.response.song.media.find(
						med => med.provider === 'soundcloud'
					) !== undefined
				) {
					that.soundCloudUrl = res.data.response.song.media.find(
						med => med.provider === 'soundcloud'
					).url;
				}
				that.res = res.data.response.song;
				that.youtubeUrl =
					res.data.response.song.media.find(
						med => med.provider === 'youtube'
					) !== undefined
						? res.data.response.song.media
								.find(med => med.provider === 'youtube')
								.url.replace(
									'http://www.youtube.com/watch?v=',
									'https://www.youtube.com/embed/'
								)
						: '';
			})
			.finally(() => (this.loading = false));
	}
};
</script>
